import React, { useState } from 'react'

interface InputBoxProps {
  id: string
  label: string
  labelSuffix?: string
  placeholder?: string
  type?: 'text' | 'password'
  required?: boolean
  value: string
  onChange: (value: string) => void
}

const formatText = (text: string) => {
  return text
    .split('_')
    .map((word) =>
      word.toLowerCase() === 'url'
        ? 'URL'
        : word.toLowerCase() === 'id'
          ? 'ID'
          : word.toLowerCase() === 'api'
            ? 'API'
            : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ')
}

export const InputBox: React.FC<InputBoxProps> = ({
  id,
  label,
  labelSuffix,
  type = 'text',
  required,
  value,
  onChange
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev)
  }

  return (
    <div className=" flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium text-gray-900">
        {formatText(label)}
        {labelSuffix && ` (${labelSuffix})`}
      </label>
      <div className="z-5 relative">
        <input
          id={id}
          type={type === 'password' && isPasswordVisible ? 'text' : type}
          required={required}
          placeholder={`Enter ${formatText(id)}`}
          value={value}
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-600 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
          onChange={(e) => onChange(e.target.value)}
        />
        {type === 'password' && (
          <div
            onClick={togglePasswordVisibility}
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
            style={{ width: 20, height: 20 }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99999 3.25C14.044 3.25 17.4085 6.16 18.1142 10C17.4092 13.84 14.044 16.75 9.99999 16.75C5.95599 16.75 2.59149 13.84 1.88574 10C2.59074 6.16 5.95599 3.25 9.99999 3.25ZM9.99999 15.25C11.5296 15.2497 13.0138 14.7301 14.2096 13.7764C15.4055 12.8226 16.2422 11.4912 16.5827 10C16.2409 8.50998 15.4037 7.18 14.208 6.22752C13.0122 5.27504 11.5287 4.7564 9.99999 4.7564C8.47126 4.7564 6.98776 5.27504 5.79202 6.22752C4.59629 7.18 3.75907 8.50998 3.41724 10C3.75781 11.4912 4.5945 12.8226 5.79035 13.7764C6.9862 14.7301 8.47039 15.2497 9.99999 15.25V15.25ZM9.99999 13.375C9.10489 13.375 8.24644 13.0194 7.61351 12.3865C6.98057 11.7535 6.62499 10.8951 6.62499 10C6.62499 9.10489 6.98057 8.24645 7.61351 7.61351C8.24644 6.98058 9.10489 6.625 9.99999 6.625C10.8951 6.625 11.7535 6.98058 12.3865 7.61351C13.0194 8.24645 13.375 9.10489 13.375 10C13.375 10.8951 13.0194 11.7535 12.3865 12.3865C11.7535 13.0194 10.8951 13.375 9.99999 13.375ZM9.99999 11.875C10.4973 11.875 10.9742 11.6775 11.3258 11.3258C11.6774 10.9742 11.875 10.4973 11.875 10C11.875 9.50272 11.6774 9.02581 11.3258 8.67417C10.9742 8.32254 10.4973 8.125 9.99999 8.125C9.50271 8.125 9.0258 8.32254 8.67417 8.67417C8.32254 9.02581 8.12499 9.50272 8.12499 10C8.12499 10.4973 8.32254 10.9742 8.67417 11.3258C9.0258 11.6775 9.50271 11.875 9.99999 11.875Z"
                fill="#99A0AE"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  )
}
